// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3WR6y","row":"Node_row___zuRj","label":"Node_label__11H0V","footer":"Node_footer__7O0ES"};